import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import moment from "moment";
import { getValidationErrorMessage } from "../../../../utils/validations/validations";
// eslint-disable-next-line import/no-cycle
import DateSelect from "./dateSelect";

function ExpirationDate({
  itemData,
  id,
  config,
  error,
  updateItem,
  updateItemValidationError,
  disabled,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <DateSelect
      title={t("expirationDate")}
      optional={config.optional}
      date={itemData.expirationDate}
      onSelect={date => {
        dispatch(
          updateItemValidationError(itemData.uuid, { expirationDate: "" })
        );
        dispatch(
          updateItem({
            ...itemData,
            expirationDate: date ? moment(date).format("YYYY-MM-DD") : null,
          })
        );
      }}
      id={`${id}-expiration-date`}
      error={!!error}
      helperText={getValidationErrorMessage(error, t)}
      placeholder={t("datepickerPlaceholder")}
      disableFuture={false}
      width="200px"
      disabled={disabled}
    />
  );
}

ExpirationDate.propTypes = {
  itemData: PropTypes.shape({
    expirationDate: PropTypes.string,
    uuid: PropTypes.string,
  }),
  id: PropTypes.string,
  config: PropTypes.shape({
    optional: PropTypes.bool,
  }),
  error: PropTypes.string,
  updateItem: PropTypes.func,
  updateItemValidationError: PropTypes.func,
  disabled: PropTypes.bool,
};

ExpirationDate.defaultProps = {
  itemData: {},
  id: "",
  config: {},
  error: "",
  updateItem: null,
  updateItemValidationError: null,
  disabled: false,
};

export default ExpirationDate;
